import { FC, useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

import CustomAutoSelect from '../CustomAutoSelect';
import { useGetLocationsQuery } from '../../store/services/authApi';

import styles from './CountrySelect.module.scss';

interface CountrySelectProps {
  name: string;
  inputLabel: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
}

const CountrySelect: FC<CountrySelectProps> = ({ name, inputLabel, value, onChange, error }) => {
  const [countryInput, setCountryInput] = useState('');
  const [countrySearch, setCountrySearch] = useState('');

  const { data: countries } = useGetLocationsQuery({
    search: countrySearch,
    type: 'country',
  });

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCountrySearch(countryInput);
    }, 500);

    return () => clearTimeout(timeout);
  }, [countryInput]);

  const handleChange = (event: React.SyntheticEvent<Element, Event>, selectedValue: { name: string } | null) => {
    const syntheticEvent = {
      target: {
        name,
        value: selectedValue ? selectedValue.name : '',
      },
    } as React.ChangeEvent<HTMLInputElement>;

    onChange(syntheticEvent);
  };

  return (
    <Box className={styles.customSelectContainer}>
      <CustomAutoSelect
        options={countries ?? []}
        inputLabel={inputLabel}
        placeholder="Enter country name"
        handleChange={handleChange}
        onInputChange={(event, inputValue) => {
          setCountryInput(inputValue);
        }}
        value={value ? { name: value } : null}
        customClass={styles.customInput}
      />
      {error && (
        <Typography
          variant="h12"
          sx={{ color: '#C8102E', mt: 1 }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default CountrySelect;
